/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FinancialsPrizePool } from './FinancialsPrizePool';
import {
    FinancialsPrizePoolFromJSON,
    FinancialsPrizePoolFromJSONTyped,
    FinancialsPrizePoolToJSON,
    FinancialsPrizePoolToJSONTyped,
} from './FinancialsPrizePool';
import type { FinancialsPenalties } from './FinancialsPenalties';
import {
    FinancialsPenaltiesFromJSON,
    FinancialsPenaltiesFromJSONTyped,
    FinancialsPenaltiesToJSON,
    FinancialsPenaltiesToJSONTyped,
} from './FinancialsPenalties';
import type { FinancialsRefunds } from './FinancialsRefunds';
import {
    FinancialsRefundsFromJSON,
    FinancialsRefundsFromJSONTyped,
    FinancialsRefundsToJSON,
    FinancialsRefundsToJSONTyped,
} from './FinancialsRefunds';

/**
 * Financial summary object inside FinancialsResponse
 * @export
 * @interface FinancialsSummary
 */
export interface FinancialsSummary {
    /**
     * 
     * @type {string}
     * @memberof FinancialsSummary
     */
    tournamentId?: string;
    /**
     * 
     * @type {string}
     * @memberof FinancialsSummary
     */
    tournamentName?: string;
    /**
     * 
     * @type {number}
     * @memberof FinancialsSummary
     */
    entryFee?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialsSummary
     */
    registeredTeams?: number;
    /**
     * 
     * @type {number}
     * @memberof FinancialsSummary
     */
    totalEntryFees?: number;
    /**
     * 
     * @type {FinancialsPrizePool}
     * @memberof FinancialsSummary
     */
    prizePool?: FinancialsPrizePool;
    /**
     * 
     * @type {FinancialsRefunds}
     * @memberof FinancialsSummary
     */
    refunds?: FinancialsRefunds;
    /**
     * 
     * @type {FinancialsPenalties}
     * @memberof FinancialsSummary
     */
    penalties?: FinancialsPenalties;
    /**
     * 
     * @type {number}
     * @memberof FinancialsSummary
     */
    netRevenue?: number;
}

/**
 * Check if a given object implements the FinancialsSummary interface.
 */
export function instanceOfFinancialsSummary(value: object): value is FinancialsSummary {
    return true;
}

export function FinancialsSummaryFromJSON(json: any): FinancialsSummary {
    return FinancialsSummaryFromJSONTyped(json, false);
}

export function FinancialsSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialsSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'tournamentName': json['tournamentName'] == null ? undefined : json['tournamentName'],
        'entryFee': json['entryFee'] == null ? undefined : json['entryFee'],
        'registeredTeams': json['registeredTeams'] == null ? undefined : json['registeredTeams'],
        'totalEntryFees': json['totalEntryFees'] == null ? undefined : json['totalEntryFees'],
        'prizePool': json['prizePool'] == null ? undefined : FinancialsPrizePoolFromJSON(json['prizePool']),
        'refunds': json['refunds'] == null ? undefined : FinancialsRefundsFromJSON(json['refunds']),
        'penalties': json['penalties'] == null ? undefined : FinancialsPenaltiesFromJSON(json['penalties']),
        'netRevenue': json['netRevenue'] == null ? undefined : json['netRevenue'],
    };
}

export function FinancialsSummaryToJSON(json: any): FinancialsSummary {
    return FinancialsSummaryToJSONTyped(json, false);
}

export function FinancialsSummaryToJSONTyped(value?: FinancialsSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournamentId': value['tournamentId'],
        'tournamentName': value['tournamentName'],
        'entryFee': value['entryFee'],
        'registeredTeams': value['registeredTeams'],
        'totalEntryFees': value['totalEntryFees'],
        'prizePool': FinancialsPrizePoolToJSON(value['prizePool']),
        'refunds': FinancialsRefundsToJSON(value['refunds']),
        'penalties': FinancialsPenaltiesToJSON(value['penalties']),
        'netRevenue': value['netRevenue'],
    };
}

